<template>
  <div class="verifyPhone">
    <el-form
      :model="ruleForm"
      status-icon
      :rules="rules"
      ref="ruleForm"
      label-width="85px"
      class="demo-ruleForm"
    >
      <el-row :gutter="20">
        <el-col :xs="24" :sm="24" :md="24">
          <el-form-item label="手机号码" prop="phone">
            <el-input v-model="ruleForm.phone">
              <template slot="prepend">{{ruleForm.countryCode}}</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24">
          <el-form-item label prop="code">
            <el-input v-model="ruleForm.code">
              <el-button
                slot="append"
                @click="getCode('ruleForm')"
                class="verificationCode"
                style="color: #67c23a"
                :disabled="timeLoading"
              >{{!timeLoading?'获取验证码':checkTime+'S重新获取'}}</el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <!-- <el-col :xs="24" :sm="24" :md="24">
          <el-form-item v-if="tipsHide">
            <span>我们已经发送一条验证短信至</span>
            <span style="color:#F56C6C">{{tips}}</span>
          </el-form-item>
        </el-col>-->
        <el-col :xs="24" :sm="24" :md="24">
          <el-form-item class="button">
            <el-button
              type="danger"
              style="width:150px;height:40px"
              @click="registerrNow('ruleForm')"
            >立即注册</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { isMobile } from "@/util/validate.js";
import { setStore, getStore } from "@/util/store";
import { GetMessageCode, CheckPhoneNumber } from "@/api/admin/login.js";

var checkPhone = (rule, value, callback) => {
  if (!value) {
    callback(new Error("请输入联系方式"));
  } else {
    if (isMobile(value)) {
      callback();
    } else {
      return callback(new Error("请输入正确的电话"));
    }
  }
};
var checkCode = (rule, value, callback) => {
  if (value === "") {
    callback(new Error("请输入验证码"));
  } else {
    if (String(value).length == 4) {
      callback();
    } else {
      return callback(new Error("请输入四位数验证码"));
    }
  }
};
export default {
  data() {
    return {
      ruleForm: {
        phone: "",
        code: "",
        countryCode: "+86"
      },
      rules: {
        phone: [{ validator: checkPhone, trigger: "blur" }],
        code: [{ validator: checkCode, trigger: "blur" }]
      },
      tipsHide: false,
      checkTime: "",
      timeLoading: false,
      timer: null
    };
  },
  props: {
    next: Function
  },
  methods: {
    getCode(ruleForm) {
      this.$refs[ruleForm].validateField("phone", errMsg => {
        if (!errMsg) {
          GetMessageCode({ mobile: this.ruleForm.phone }).then(data => {
            
            const list = data.data.result;
            if (list) {
              if (list.isSuccess) {
                this.$message({
                  message:
                    "验证码已成功发送至“ " +
                    this.ruleForm.phone +
                    " ”请您注意查收",
                  type: "success",
                  duration: "5000"
                });
                if (!this.timer) {
                  this.checkTime = 120;
                  this.timeLoading = true;
                  this.timer = setInterval(() => {
                    if (this.checkTime > 0 && this.checkTime <= 120) {
                      this.checkTime--;
                    } else {
                      clearInterval(this.timer);
                      this.timeLoading = false;
                      this.timer = null;
                    }
                  }, 1000);
                }
              } else {
                this.$message.error("验证码发送失败，请重新获取");
              }
            }
          });
        }
      });
    },
    registerrNow(ruleForm) {
      this.$refs[ruleForm].validate(valid => {
        if (valid) {
          CheckPhoneNumber({
            mobile: this.ruleForm.phone,
            userType: getStore({ name: "register_role" }),
            code: this.ruleForm.code
          }).then(data => {
            
            const list = data.data.result;
            if (list) {
              if (list.isSuccess) {
                this.next();
                setStore({
                  name: "mobile",
                  content: {
                    mobile: this.ruleForm.phone
                  },
                  type: "session"
                });
              } else {
                this.$message({
                  message: list.errorMsg,
                  type: "warning",
                  duration: "3000"
                });
              }
            }
          });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style lang="less">
.verifyPhone {
  width: 80%;
  margin: 0 auto;
  .el-input-group__append:hover {
    opacity: 0.7;
  }
  .button {
    text-align: center;
    margin: 50px 0px;
    .el-form-item__content {
      margin-left: 0px !important;
    }
  }
}
@media screen and (max-width: 768px) {
  .register_content {
    .verifyPhone {
      width: 100% !important;
    }
    .el-card__body {
      padding: 20px 10px;
      .verificationCode {
        font-size: 12px !important;
        width: 90px;
        color: #67c23a !important;
      }
    }
  }
}
@media screen and (max-width: 500px) {
  .verifyPhone {
    width: 100% !important;
  }
}
</style>